import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Router } from '@angular/router';
import { AquabotService } from 'src/app/services/aquabot.service';

@Component({
  selector: 'app-apadrinamiento-modal',
  templateUrl: './apadrinamiento-modal.component.html',
  styleUrls: ['./apadrinamiento-modal.component.scss'],
})

export class ApadrinamientoModalComponent {

  constructor(
    private modalCtrl: ModalController,
    private router: Router,
    private aquabot: AquabotService
  ) { }

  payMercadoPago(link:any, title:any) {
    console.log('abrir ventana url mercadopago');
    // Aquí puedes implementar window.open o Capacitor Browser plugin
    this.aquabot.enlaceSugerido(link, title);
  }

  payPayPal(link:any, title:any) {
    console.log('abrir ventana url paypal');
    // Aquí puedes implementar window.open o Capacitor Browser plugin
    this.aquabot.enlaceSugerido(link, title);
  }

  sitioProyectos(link:any, title:any) {
    console.log('abrir ventana url paypal');
    // Aquí puedes implementar window.open o Capacitor Browser plugin
    this.aquabot.enlaceSugerido(link, title);
  }

  goToProjects() {
    this.dismissModal();
    this.router.navigate(['/proyectos']);
  }

  dismissModal() {
    this.modalCtrl.dismiss();
  }

  cerrarComponente() {
    this.modalCtrl.dismiss(); // O usa router.navigateBack si no estás en modal
  }
}
